var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {},
    [
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            location: _vm.location || "bottom",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c(
                    "v-icon",
                    _vm._g(
                      {
                        staticStyle: { color: "rgb(0, 0, 0)" },
                        attrs: { title: "Filtra" },
                      },
                      on
                    ),
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.initialValue
                              ? "mdi-filter-menu"
                              : " mdi-filter-menu-outline"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.showMenu,
            callback: function ($$v) {
              _vm.showMenu = $$v
            },
            expression: "showMenu",
          },
        },
        [
          _c(
            "v-card",
            { staticStyle: { padding: "10px" }, attrs: { "min-width": "50" } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.operators,
                  "item-text": "label",
                  "item-value": "value",
                  "menu-props": { top: false, "offset-y": true },
                },
                model: {
                  value: _vm.operatorSelected,
                  callback: function ($$v) {
                    _vm.operatorSelected = $$v
                  },
                  expression: "operatorSelected",
                },
              }),
              _c("v-divider"),
              _vm.type === "number"
                ? _c("v-text-field", {
                    attrs: { label: "Cerca", type: "number" },
                    model: {
                      value: _vm.filterNumber,
                      callback: function ($$v) {
                        _vm.filterNumber = $$v
                      },
                      expression: "filterNumber",
                    },
                  })
                : _vm.type === "multiselect"
                ? _c("MultiSelect", {
                    attrs: {
                      label: "Cerca",
                      dataSource: _vm.dataSource,
                      initialValue: _vm.multiSelectInitialValue,
                    },
                    on: { change: _vm.onSelectChange },
                  })
                : _c("v-text-field", {
                    attrs: { label: "Cerca" },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText",
                    },
                  }),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { variant: "text" },
                      on: { click: _vm.onRemoveFilter },
                    },
                    [_vm._v("Rimuovi")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", variant: "text" },
                      on: { click: _vm.onSaveFilter },
                    },
                    [_vm._v("Applica")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }